






























































































































import Vue from 'vue';

import { iconsMixin } from '@/mixins/icons';
import { breakpointsMixin } from '@/mixins/breakpoints';
import { authMixin } from '@/mixins/auth';
import { formatMixin } from '@/mixins/format';

import exportService from '@/services/ExportService';
import outboundDispatchStatusService from '@/services/OutboundDispatchStatusService';
import { OutboundDispatchStatus } from '@/models/outboundDispatchStatus/OutboundDispatchStatus';
import { OutboundDispatchStatusResponse } from '@/models/outboundDispatchStatus/OutboundDispatchStatusResponse';

export default Vue.extend<any, any, any, any>({
  mixins: [iconsMixin, breakpointsMixin, authMixin, formatMixin],
  data() {
    return {
      searchTerm: '',
      currentPage: 1,
      pageSize: 10,
      totalCount: 0,
      dispatchRecords: [] as any[],
      page: [] as any[],
      loading: false,
      displayFilters: false,
      searchOptions: {
        shipmentId: '',
        status: '',
        carrierId: '',
        carrierResponse: '',
        pickupNumber: '',
        shipmentCreatedDate: '',
        carrierNotifiedDate: '',
        responseDate: '',
        accountId: '',
      },
      clearTrigger: false,
    };
  },
  created() {
    this.fetch();
  },
  methods: {
    async fetch() {
      this.loading = true;

      try {
        const userId = this.user?.userId;

        // prepare filters for server-side filtering
        const filters = {
          shipmentId: this.searchOptions.shipmentId || '',
          status: this.searchOptions.status || '',
          carrierId: this.searchOptions.carrierId || '',
          carrierResponse: this.searchOptions.carrierResponse || '',
          pickupNumber: this.searchOptions.pickupNumber || '',
          shipmentCreatedDate: this.searchOptions.shipmentCreatedDate || '',
          carrierNotifiedDate: this.searchOptions.carrierNotifiedDate || '',
          responseDate: this.searchOptions.responseDate || '',
          accountId: this.searchOptions.accountId || '',
        };

        const response: OutboundDispatchStatusResponse =
          await outboundDispatchStatusService.getOutboundDispatchStatuses(
            userId,
            this.currentPage,
            this.pageSize,
            filters
          );

        // pap API response to expected grid format
        this.dispatchRecords = response.data.map(
          (item: OutboundDispatchStatus) => ({
            shipmentId: item.shipmentId,
            carrierName: item.name,
            clientName: item.company,
            status: item.status,
            shipmentCreated: this.formatDateTime(item.createdDatetime),
            carrierNotified: this.formatDateTime(item.processedDatetime),
            carrierResponse: item.responseStatus,
            pickupNumber: item.pickupRefNumbers,
            responseDate: this.formatDateTime(item.responseDatetime),
            loadId: item.loadId,
            processed: item.processed,
            // keep original dates for filtering
            _createdDatetime: item.createdDatetime,
            _processedDatetime: item.processedDatetime,
            _responseDatetime: item.responseDatetime,
          })
        );

        this.page = this.dispatchRecords;
        this.totalCount = response.totalCount;
      } catch (error) {
        console.error('Error fetching outbound dispatch status:', error);
        this.dispatchRecords = [];
        this.page = [];
        this.totalCount = 0;
      } finally {
        this.loading = false;
      }
    },
    formatDateTime(dateTime: string): string {
      if (!dateTime) return '';
      try {
        const date = new Date(dateTime);
        return date.toLocaleString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          hour12: true,
        });
      } catch (error) {
        return dateTime;
      }
    },
    search(options: any) {
      this.searchOptions = { ...this.searchOptions, ...options };

      // sync shipmentId with searchTerm if it was updated from filters
      if (options.shipmentId !== undefined) {
        this.searchTerm = options.shipmentId;
      }

      this.currentPage = 1;
      this.fetch();
    },
    applySearch() {
      // use searchTerm as shipmentId for quick search
      this.searchOptions.shipmentId = this.searchTerm;
      this.currentPage = 1;
      this.fetch();
    },
    clearSearch() {
      this.searchTerm = '';
      this.searchOptions.shipmentId = '';
      this.currentPage = 1;
      this.fetch();
    },
    pageChange(page: number) {
      this.currentPage = page;
      this.fetch();
    },
    async csvExport() {
      this.loading = true;

      try {
        const userId = this.user?.userId;

        // prepare filters for server-side filtering (same as current filters)
        const filters = {
          shipmentId: this.searchOptions.shipmentId || '',
          status: this.searchOptions.status || '',
          carrierId: this.searchOptions.carrierId || '',
          carrierResponse: this.searchOptions.carrierResponse || '',
          pickupNumber: this.searchOptions.pickupNumber || '',
          shipmentCreatedDate: this.searchOptions.shipmentCreatedDate || '',
          carrierNotifiedDate: this.searchOptions.carrierNotifiedDate || '',
          responseDate: this.searchOptions.responseDate || '',
          accountId: this.searchOptions.accountId || '',
        };

        // get first page with 1000 records for CSV export
        const response: OutboundDispatchStatusResponse =
          await outboundDispatchStatusService.getOutboundDispatchStatuses(
            userId,
            1,
            1000,
            filters
          );

        // map API response to expected CSV format
        const csvData = response.data.map((item: OutboundDispatchStatus) => ({
          shipmentId: item.shipmentId,
          carrierName: item.name,
          clientName: item.company,
          status: item.status,
          shipmentCreated: this.formatDateTime(item.createdDatetime),
          carrierNotified: this.formatDateTime(item.processedDatetime),
          carrierResponse: item.responseStatus,
          pickupNumber: item.pickupRefNumbers,
          responseDate: this.formatDateTime(item.responseDatetime),
          loadId: item.loadId,
          processed: item.processed,
        }));

        // download the CSV
        exportService.csvDownload(csvData, 'Outbound-Dispatch-Status');
      } catch (error) {
        console.error('Error exporting outbound dispatch status:', error);
      } finally {
        this.loading = false;
      }
    },

    clearFilters() {
      this.searchOptions = {
        shipmentId: '',
        status: '',
        carrierId: '',
        carrierResponse: '',
        pickupNumber: '',
        shipmentCreatedDate: '',
        carrierNotifiedDate: '',
        responseDate: '',
        accountId: '',
      };
      this.searchTerm = '';
      this.currentPage = 1;

      // trigger filters component to clear its state
      this.clearTrigger = !this.clearTrigger;

      this.fetch();
    },
  },
  computed: {
    pagingLength() {
      return Math.ceil(this.totalCount / this.pageSize);
    },
  },
});
